import { apiFetch } from "@core/http";
import type {
  CatalogEntry,
  CatalogEntryInput,
  CatalogEntryUpdate,
  CatalogName,
  CatalogSummary,
  CatalogUses,
} from "@core/types";

const base = (catalog: CatalogName) =>
  `/v1/portal/catalogs/${encodeURIComponent(catalog)}/entries`;

export const listCatalogs = () =>
  apiFetch<CatalogSummary[]>("/v1/portal/catalogs");
export const listEntries = (
  catalog: CatalogName,
  query: { includeInactive: boolean; search: string },
) => {
  const params = new URLSearchParams();
  if (query.includeInactive) params.set("includeInactive", "true");
  if (query.search.trim()) params.set("search", query.search.trim());
  const suffix = params.size ? `?${params}` : "";
  return apiFetch<CatalogEntry[]>(`${base(catalog)}${suffix}`);
};
export const getEntry = (catalog: CatalogName, id: string) =>
  apiFetch<CatalogEntry>(`${base(catalog)}/${encodeURIComponent(id)}`);
export const createEntry = (catalog: CatalogName, input: CatalogEntryInput) =>
  apiFetch<CatalogEntry>(base(catalog), { method: "POST", body: input });
export const editEntry = (
  catalog: CatalogName,
  id: string,
  input: CatalogEntryUpdate,
) =>
  apiFetch<CatalogEntry>(`${base(catalog)}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });
export const inactivateEntry = (catalog: CatalogName, id: string) =>
  apiFetch<void>(`${base(catalog)}/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
export const entryUses = (catalog: CatalogName, id: string) =>
  apiFetch<CatalogUses>(`${base(catalog)}/${encodeURIComponent(id)}/uses`);
